import mixpanel from 'mixpanel-browser'

window.mixpanel = (userId, profile) => {
  mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    debug: import.meta.env.VITE_MIXPANEL_DEBUG ?? true,
    track_pageview: false,
    persistence: 'localStorage'
  })

  let userProfile = profile ? {
    $name: profile.name,
    $email: profile.email
  } : undefined

  mixpanel.identify(userId)

  if (userProfile !== undefined) {
    mixpanel.people.set_once(userProfile)
  }

  return mixpanel
}
